<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>
        <feather-icon icon="GlobeIcon" size="33" :class="'text-primary'" />

        {{ $t('Geofences Statistics') }}
      </b-card-title>

    </b-card-header>

    <b-card-body>

      <b-row>
        <b-col sm="12" md="6" xl="6">
          <vue-apex-charts type="radialBar" :height="chartHeight(Object.keys(info.Categories).length)"
            :options="productOrdersRadialBar.chartOptions" :series="serc" />
        </b-col>
        <b-col sm="12" md="6" xl="6">
          <b-table striped hover responsive :per-page="10" :current-page="1" :items="info.CategoriesData"  @row-clicked="(item, index, event)=> this.showDevicesList(item, index, event)"
            :fields="[{ key: 'name', label: $t('name') }, { key: 'count', label: $t('Total') }, { key: 'devicesVisitedTodayTotal', label: $t('Devices Visited Today') }]">
            <template #cell(name)="data">
              <span :style="`color:${customColors[data.index]} ;font-size:small;font-weight: bolder;`">{{
                $t(data.item.name) }}</span>
            </template>
          </b-table>
        </b-col>
      </b-row>

      <list-modal ref="devicesModal"/>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BDropdown, BDropdownItem, BCardBody,
  BTable,
  BRow,
  BCol,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import ListModal from './modals/ListModal.vue'

const cartColors =
  [
    "#F8696B", "#C35500", "#63BE7B", "#2e5899",
    '#8e44ad', '#273746', '#117864', '#34495e',
    "#7b7d7d", "#00FFFF", "#63BE7B", "#2e5899",
    '#D81B60', '#C2185B', '#AD1457', '#880E4F', '#FF80AB',
    '#FF4081', '#F50057', '#C51162', '#9C27B0', '#F3E5F5',
  ]

export default {

  components: {
    VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle,
    BDropdown,
    BDropdownItem,
    BCardBody,
    BTable,
    BRow,
    BCol,
    ListModal
  },
  props: {
    info: {
      type: Object,
      default: () => { defaultData }
    },

  },


  data() {



    return {

      defaultData: { "WORK_AREA": 6360, "CAMP_AREA": 38, "LANDFILL_AREA": 16 },

      customColors: cartColors.slice(0, Object.keys(this.info.Categories).length),
      customColorsReverse: cartColors.slice(0, Object.keys(this.info.Categories).length).reverse(),
      chartInfo: {},

      productOrdersRadialBar: {
        series: [89, 42, 3, 55, 55, 9],
        chartOptions: {
          //labels:this.xlabel,
          //labels:Object.keys(this.info.Categories),
          labels: Object.keys(this.info.Categories).map(i => this.$t(i)),
          colors: cartColors.slice(0, Object.keys(this.info.Categories).length),
          plotOptions: {
            radialBar: {
              size: 12,
              hollow: {
                size: '20%',
              },
              track: {
                strokeWidth: '100%',
                margin: 15,
              },
              dataLabels: {
                value: {
                  fontSize: '1rem',
                  colors: '#5e5873',
                  fontWeight: '500',
                  offsetY: 5,
                },
                total: {
                  show: true,
                  label: this.$t('Total'),
                  fontSize: '1.286rem',
                  colors: '#5e5873',
                  fontWeight: '500',

                  formatter(w) {
                    return "100%"
                    ///  console.log( w.globals.series)
                    // return   `${ w.globals.series[0]}%`;
                  },
                },
              },
            },
          },
          // colors: this.customcolors,
          stroke: {
            lineCap: 'round',
          },
          chart: {
            height: 355,
            dropShadow: {
              enabled: true,
              blur: 3,
              left: 1,
              top: 1,
              opacity: 0.1,
            },
          },
        },
      },
    }
  },
  methods: {
    chartHeight(count) {
      //console.log(count)
      if (count <= 2) {
        return 200;
      }
      if (count <= 6) {
        return count * 70;
      }
      return count * 55;
    },
    showDevicesList(item) {
      this.$refs.devicesModal.showModal({
        title:`${this.$root.$t('Devices Visited')} - ${this.$root.$t(item.name)}`,
        list:item.devicesVisitedToday,
        fields:[{key:'contract', label:'contract'}, {key:'name', label:'device'}, {key:'geofence', label:'Area'}, {key:'time', label:'time'}]
      })
    }

  },
  computed: {

    labels() {
      if (this.info) {
        console.log()
        //return   Object.keys(this.info.Categories);

      }
      return ['Finished', 'Pending', 'Rejected'];
    },
    serc() {
      let inf_data = this.info;
      if (inf_data) {
        let obj = inf_data.Categories;
        var result = Object.keys(obj).map((key) => Math.ceil(obj[key] / inf_data.Total * 100));
        // console.log(inf_data.Total);

      }

      return result;
    }
  }
}
</script>
